import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
    * **In1Solutions**
    *
    * @exports bs_472
    * @category engines
    */
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, numChildren, nights) => {
        const ratesArray = Array.from(document.querySelectorAll('result-list-card'));
        if (thn.empty(ratesArray)) {
            return [];
        }
        const ratesInfo = ratesArray.map((rate) => {
            const rateName = rate.querySelector('.resultListCard__header')?.textContent || '';
            const hasBreakfast = !!rateName?.match(/Breakfast|Desayuno|Ontbijt|dejun|ze ?niadaniem/);
            const isRefundable = true;
            return {
                name: rateName,
                breakfast: hasBreakfast,
                refundable: isRefundable,
            };
        });
        const roomsArray = Array.from(document.querySelectorAll('result-child-item'));
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.resultChildItem__cellHeaderText')?.textContent?.trim() || '';
            const roomType = getRoomType(roomName);
            const roomPrice = thn.parseNumber(room.querySelector('.current-price')?.textContent);
            if (!roomName || !roomPrice) {
                return null;
            }
            const prices = ratesInfo.map((rate) => ({
                name: rate.name,
                totalNight: roomPrice / nights,
                breakfast: rate.breakfast,
                refundable: rate.refundable,
            }));
            return {
                name: roomName,
                adults: numAdults || 2,
                children: 0,
                type: roomType,
                prices,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const lang = document.querySelector('.navbarContainer button span[translate]')?.getAttribute('translate')?.slice(-2);
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 500),
        boot() {
            const container = document.querySelector('#wrapper');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                    thn.languageCheck().catch(() => { });
                }, 600);
                thn.observeDom(container, refreshPage, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('#wrapper');
            if (container) {
                const refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh().catch(() => { });
                    thn.languageCheck().catch(() => { });
                }, 600);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                    }
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.pathname.match(/search\/results/);
            // https://www.bookin1.com/bookingEngine/hotel/whthuk/search/results?type=rate&date=2024-09-11&los=1
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            url.searchParams.set('date', '[date_begin]');
            url.searchParams.set('los', '[nights]');
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Dates
            // From datalayer
            const dateBeginDl = thn.dataLayerHelper.get('checkIn')?.replace(/-/g, '/');
            const dateEndDl = thn.dataLayerHelper.get('checkOut')?.replace(/-/g, '/');
            // From URL
            const dateBeginUrl = thn.parseUrlParameter('date')?.replace(/-/g, '/');
            const nights = thn.parseNumber(thn.parseUrlParameter('los'));
            let dateEndUrl;
            if (dateBeginUrl && nights) {
                const dateEndResult = thn.dateToString(thn.addDays(dateBeginUrl, nights));
                dateEndUrl = dateEndResult !== null ? dateEndResult : undefined;
            }
            const dateBegin = dateBeginDl || dateBeginUrl;
            const dateEnd = dateEndDl || dateEndUrl;
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Price and currency
            const pricesArray = Array.from(document.querySelectorAll('result-child-item'));
            const pricesFiltered = pricesArray.filter((item) => {
                const roomsLeft = item.querySelector('.rooms-left > span');
                return !roomsLeft?.textContent?.match(/No Rooms Left/);
            }).map((item) => {
                const price = thn.parseNumber(item.querySelector('.current-price')?.textContent);
                return { price, element: item };
            }).filter(room => typeof room.price !== 'undefined');
            const cheapestRoom = pricesFiltered.reduce((minRoom, currentRoom) => (currentRoom.price !== undefined && (minRoom.price === undefined || currentRoom.price < minRoom.price) ? currentRoom : minRoom), pricesFiltered[0]);
            const price = cheapestRoom?.price;
            const currency = thn.parseCurrency(document.querySelector('.current-price')?.textContent);
            // Guests
            let adults = 1;
            const children = 0;
            if (cheapestRoom) {
                const guestsEl = cheapestRoom.element.querySelector('.occupancyContainer .occupancy:not(.ng-hide *)');
                adults = thn.parseNumber(guestsEl?.className?.split('icon-max')?.[1]) || 1;
            }
            // No availability
            const noAvailability = document.querySelector('.no-availability');
            if (price && nights && currency) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    roomDetails: roomDetailsParseData(adults, children, nights),
                    price: price / nights,
                    currency,
                };
            }
            if (!price || noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = thn.parseUrlParameter('confirmationRef') || document.querySelector('payment-status span')?.textContent?.split(':')[1].trim();
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const dates = document.querySelector('.reservation-segment .meta')?.textContent?.split('—');
            const dateBeginNoFormat = dates?.[0].trim();
            const dateEndNoFormat = dates?.[1].trim();
            const dateBegin = dateBeginNoFormat ? translateDate(dateBeginNoFormat, thn.data.language) : '';
            const dateEnd = dateEndNoFormat ? translateDate(dateEndNoFormat, thn.data.language) : '';
            const price = thn.parseNumber(document.querySelector('.costs-summary > div span:nth-child(2)')?.textContent);
            const currency = thn.parseCurrency(document.querySelector('.costs-summary > div span:nth-child(2)')?.textContent);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
